/**
 * Created by amir on 6/20/18.
 */

export default class EventHelperService {
    static get $inject() {
        return ['ApiAccountService'];
    }

    constructor(ApiAccountService) {

        this.ApiAccountService = ApiAccountService;
        this.ApiAccountService.getEventsTypesList().then(resp => {
            this.EVENTS_CIDS_TEXTS = resp.data;
        });
    }

    static get EVENTS_CIDS_TEXTS() {

        return this.EVENTS_CIDS_TEXTS;
    }

}


/** WEBPACK FOOTER **
 ** ./src/services/app/event.helper.service.js
 **/